/* ATOM LED — All Reviews Page
 * - Loads atom-reviews-all.json (~340 KB)
 * - Hydrates cards beyond the first 24 SSR'd in Liquid
 * - Filters: 5★ / 4★+ / 3★+ / Google / With photos
 * - Load-more pagination (24 per click)
 *
 * Built with safe DOM methods (createElement + textContent) — no innerHTML
 * for user-supplied data, eliminating XSS surface even though the JSON
 * comes from our own controlled pipeline.
 */
(function () {
  'use strict';

  var PAGE_SIZE = 24;

  // Globo add-on "option-set-*" shadow products have no real product page. Feed rows carry pid but no handle,
  // so list the ids (Admin API, 2026-10-31); a review filed against one keeps its card but shows no product line.
  var SHADOW_PIDS = [8217300041986, 8217429737730, 8224168083714, 8227057074434, 8251934769410, 8251934802178, 8265146827010, 8401459347714, 8801302151426, 14859503796608, 15076474618240, 15076474651008, 15150456570240, 15242840539520, 15242840605056, 15242841325952, 15934303240576, 15945684779392, 15969944994176];

  function init() {
    var grid = document.querySelector('[data-ar-all-grid]');
    var loadMoreBtn = document.querySelector('[data-ar-loadmore]');
    var loadMoreStatus = document.querySelector('[data-ar-loadmore-status]');
    var filterBtns = document.querySelectorAll('.ar-all-filter');
    var disclosureBtn = document.querySelector('[data-ar-show-all]');
    if (!grid || !loadMoreBtn) return;

    // Default view comes from whichever chip is marked active in the Liquid
    // markup (currently 4★+); "All" remains one click away.
    var initialBtn = document.querySelector('.ar-all-filter.is-active');
    var state = {
      allReviews: [],
      currentFilter: (initialBtn && initialBtn.dataset.filter) || 'all',
      visibleCount: 24,
      filteredTotal: 0,
      isLoaded: false,
      fetchFailed: false,
    };

    function resolveAssetUrl() {
      // Preferred: the Liquid-provided asset_url, which carries Shopify's ?v=
      // cache-buster — without it the CDN can serve a stale JSON for days
      // (caused dead old-slug photo URLs on 2026-06-10).
      var grid = document.querySelector('[data-ar-feed-url]');
      if (grid && grid.getAttribute('data-ar-feed-url')) {
        return grid.getAttribute('data-ar-feed-url');
      }
      // Fallback: derive the theme asset path from any loaded asset link
      var any = document.querySelector('link[href*="/cdn/shop/t/"]');
      if (any) {
        var m = any.href.match(/\/cdn\/shop\/t\/(\d+)\//);
        if (m) return '/cdn/shop/t/' + m[1] + '/assets/atom-reviews-all.json';
      }
      return '/cdn/shop/t/40/assets/atom-reviews-all.json';
    }

    function fetchData() {
      return fetch(resolveAssetUrl()).then(function (r) {
        if (!r.ok) throw new Error('HTTP ' + r.status);
        return r.json();
      });
    }

    function applyFilter(filter) {
      return state.allReviews.filter(function (r) {
        switch (filter) {
          case '5':        return r.r === 5;
          case '4plus':    return r.r >= 4;
          case '3plus':    return r.r >= 3;
          case 'google':   return r.s === 'google-business';
          case 'photos':   return Array.isArray(r.p) && r.p.length > 0;
          default:         return true;
        }
      });
    }

    function formatDate(iso) {
      if (!iso) return '';
      var months = ['Jan','Feb','Mar','Apr','May','Jun','Jul','Aug','Sep','Oct','Nov','Dec'];
      var parts = iso.split('-');
      if (parts.length !== 3) return iso;
      return parts[2] + ' ' + months[+parts[1] - 1] + ' ' + parts[0];
    }

    function reviewTimestamp(r) {
      var raw = r && r.d ? r.d : '';
      var ts = raw ? Date.parse(raw + (raw.indexOf('T') === -1 ? 'T00:00:00' : '')) : 0;
      return Number.isNaN(ts) ? 0 : ts;
    }

    function newestFirst(a, b) {
      var dateDelta = reviewTimestamp(b) - reviewTimestamp(a);
      if (dateDelta) return dateDelta;
      return (Number(b.id) || 0) - (Number(a.id) || 0);
    }

    function el(tag, opts) {
      var e = document.createElement(tag);
      if (opts) {
        if (opts.cls) e.className = opts.cls;
        if (opts.text != null) e.textContent = opts.text;
        if (opts.attrs) {
          for (var k in opts.attrs) e.setAttribute(k, opts.attrs[k]);
        }
        if (opts.html) e.innerHTML = opts.html;  // ONLY for our own static SVG markup
      }
      return e;
    }

    // Static SVG fragments — no user data, safe to inject
    var GOOGLE_ICON_SVG = '<svg viewBox="0 0 24 24" width="14" height="14" aria-hidden="true">' +
      '<path fill="#4285F4" d="M22.5 12.27c0-.79-.07-1.54-.2-2.27H12v4.51h5.92c-.26 1.37-1.04 2.53-2.21 3.31v2.77h3.57c2.08-1.92 3.27-4.74 3.27-8.32z"/>' +
      '<path fill="#34A853" d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.15-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z"/>' +
      '<path fill="#FBBC05" d="M5.85 14.1c-.22-.66-.35-1.36-.35-2.1s.13-1.44.35-2.1V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l3.67-2.83z"/>' +
      '<path fill="#EA4335" d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.67 2.83C6.71 7.31 9.14 5.38 12 5.38z"/>' +
      '</svg>';
    var TICK_SVG = '<svg viewBox="0 0 24 24" width="13" height="13" aria-hidden="true"><path fill="currentColor" d="M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41z"/></svg>';

    // Verified badge is back on operator instruction 2026-10-31; driven only by the review's own vp flag.
    function buildBadge(r) {
      var isVerified = r.vp === true;
      var isGoogle = !isVerified && r.s === 'google-business';
      if (!isVerified && !isGoogle) return null;
      var node = isGoogle
        ? el('span', {
            cls: 'ar-badge ar-badge--google',
            attrs: { title: 'Imported from Google Business Profile' }
          })
        : el('span', { cls: 'ar-badge ar-badge--verified' });
      node.innerHTML = isGoogle ? GOOGLE_ICON_SVG : TICK_SVG;
      node.appendChild(document.createTextNode(' ' + (isGoogle ? 'Google' : 'Verified')));
      return node;
    }

    function buildStars(rating, label) {
      var div = el('div', { cls: 'ar-card-stars', attrs: { 'aria-label': label } });
      for (var i = 1; i <= 5; i++) {
        div.appendChild(el('span', {
          cls: 'ar-star ar-star--' + (i <= rating ? 'on' : 'off'),
          attrs: { 'aria-hidden': 'true' },
          text: '★'
        }));
      }
      return div;
    }

    function buildCard(r) {
      var article = el('article', {
        cls: 'ar-card ar-all-card',
        attrs: {
          'data-source': r.s,
          'data-rating': r.r,
          'data-ar-card': '',
          'tabindex': '0',
          'role': 'button',
          'aria-label': 'Read full review by ' + (r.n || 'customer')
        }
      });
      if (r.id != null) article.setAttribute('data-ar-id', r.id);

      // Header: badge (Verified or Google) + stars
      var header = el('header', { cls: 'ar-card-top' });
      var badge = buildBadge(r);
      if (badge) header.appendChild(badge);
      header.appendChild(buildStars(r.r, r.r + ' out of 5 stars'));
      article.appendChild(header);

      // Title
      if (r.t) article.appendChild(el('h3', { cls: 'ar-card-title', text: r.t }));

      // Body
      article.appendChild(el('p', { cls: 'ar-card-body', text: r.b }));

      // Customer photos (max 4 thumbs; click opens the lightbox via delegation)
      if (Array.isArray(r.p) && r.p.length) {
        var photos = el('div', { cls: 'ar-card-photos' });
        for (var pi = 0; pi < Math.min(r.p.length, 4); pi++) {
          var base = String(r.p[pi]).split('?')[0];
          var pbtn = el('button', {
            cls: 'ar-card-photo',
            attrs: {
              type: 'button',
              'data-ar-photo': base,
              'data-stop-modal': '',
              'aria-label': 'View customer photo ' + (pi + 1) + ' by ' + (r.n || 'customer')
            }
          });
          pbtn.appendChild(el('img', {
            attrs: {
              src: base + '?auto=format&w=140&h=140&fit=crop',
              alt: 'Customer photo by ' + (r.n || 'customer'),
              loading: 'lazy',
              decoding: 'async',
              width: '70',
              height: '70'
            }
          }));
          photos.appendChild(pbtn);
        }
        article.appendChild(photos);
      }

      // Product (no link in JS-rendered cards — we don't know the handle here;
      // server-rendered first 24 had handles, hydrated ones use product title only)
      if (r.pt && SHADOW_PIDS.indexOf(Number(r.pid)) === -1) {
        var prod = el('div', { cls: 'ar-card-product ar-card-product--no-link' });
        prod.appendChild(el('span', { cls: 'ar-card-product__title', text: r.pt }));
        article.appendChild(prod);
      }

      // Footer
      var footer = el('footer', { cls: 'ar-card-foot' });
      var initial = (r.n || '?').slice(0, 1).toUpperCase();
      footer.appendChild(el('span', { cls: 'ar-card-avatar', text: initial }));
      var meta = el('div', { cls: 'ar-card-meta' });
      meta.appendChild(el('span', { cls: 'ar-card-name', text: r.n }));
      var dateSpan = el('span', { cls: 'ar-card-date' });
      dateSpan.appendChild(el('time', {
        attrs: { datetime: r.d || '' },
        text: formatDate(r.d)
      }));
      meta.appendChild(dateSpan);
      footer.appendChild(meta);
      article.appendChild(footer);

      return article;
    }

    function render() {
      var filtered = applyFilter(state.currentFilter);
      state.filteredTotal = filtered.length;

      if (state.currentFilter === 'all' && !state.isLoaded) {
        // Initial state — keep SSR'd cards
        updateStatus();
        return;
      }

      // Replace grid contents
      while (grid.firstChild) grid.removeChild(grid.firstChild);

      var slice = filtered.slice(0, state.visibleCount);
      if (slice.length === 0) {
        grid.appendChild(el('div', { cls: 'ar-all-empty', text: 'No reviews match this filter.' }));
        loadMoreBtn.style.display = 'none';
      } else {
        var frag = document.createDocumentFragment();
        for (var i = 0; i < slice.length; i++) frag.appendChild(buildCard(slice[i]));
        grid.appendChild(frag);
        loadMoreBtn.style.display = state.visibleCount < filtered.length ? '' : 'none';
      }
      updateStatus();
    }

    function syncAriaPressed() {
      filterBtns.forEach(function (btn) {
        btn.setAttribute('aria-pressed', btn.classList.contains('is-active') ? 'true' : 'false');
      });
    }

    function updateStatus() {
      if (!loadMoreStatus) return;
      var shown = Math.min(state.visibleCount, state.filteredTotal || state.visibleCount);
      var total = state.filteredTotal || (state.allReviews.length || 941);
      loadMoreStatus.textContent = 'Showing ' + shown + ' of ' + total + ' reviews';
    }

    function ensureLoaded(thenFn) {
      if (state.isLoaded) { thenFn(); return; }
      if (state.fetchFailed) return;
      loadMoreBtn.classList.add('is-loading');
      fetchData().then(function (data) {
        state.allReviews = (data.reviews || []).slice().sort(newestFirst);
        state.filteredTotal = state.allReviews.length;
        state.isLoaded = true;
        loadMoreBtn.classList.remove('is-loading');
        thenFn();
      }).catch(function (err) {
        console.error('[ar-all] JSON load failed:', err);
        loadMoreBtn.classList.remove('is-loading');
        showFetchError();
      });
    }

    // ── Auto-refresh aggregate stats on page load ──
    // Pulls the latest meta from the JSON (which is regenerated daily by the
    // refresh script). Updates: 4.84 rating, 939 count, "based on N reviews",
    // each star bar (count + width %), filter counters, and load-more status.
    function showFetchError() {
      state.fetchFailed = true;
      var url = resolveAssetUrl();
      var msg = el('div', { cls: 'ar-all-fetch-error' });
      msg.appendChild(el('p', { text: 'Could not load the full review list.' }));
      var link = el('a', { text: 'Open review data', attrs: { href: url, target: '_blank', rel: 'noopener' } });
      msg.appendChild(link);
      grid.parentNode.insertBefore(msg, grid.nextSibling);
    }

    function updateStatsFromMeta(meta) {
      if (!meta) return;
      // Headline rating + count are SSR'd from the single source
      // (settings.review_avg / settings.review_count). Do NOT override them
      // here — doing so re-introduces a value that bypasses the single source.

      // Histogram rows
      var rows = document.querySelectorAll('.ar-all-dist__row');
      Array.prototype.forEach.call(rows, function (row) {
        var stars = row.getAttribute('data-stars');
        var cnt = (meta.star_dist && (meta.star_dist[stars] || meta.star_dist[+stars])) || 0;
        var pct = meta.total ? (cnt / meta.total * 100) : 0;
        var fill = row.querySelector('.ar-all-dist__fill');
        var label = row.querySelector('.ar-all-dist__count');
        if (fill) fill.style.width = pct.toFixed(2) + '%';
        if (label) label.textContent = cnt;
      });

      // Update visible total in the load-more status
      if (loadMoreStatus && meta.total) {
        var shown = Math.min(state.visibleCount, meta.total);
        loadMoreStatus.textContent = 'Showing ' + shown + ' of ' + meta.total + ' reviews';
      }
    }

    // The feed carries each review's verified-purchase flag; the SSR snapshot cards may not,
    // so once the feed is in, badge the SSR cards still in the DOM (matched by data-ar-id).
    function badgeSsrCards() {
      var byId = {};
      state.allReviews.forEach(function (r) { byId[r.id] = r; });
      Array.prototype.forEach.call(grid.querySelectorAll('[data-ar-card][data-ar-id]'), function (card) {
        var r = byId[card.getAttribute('data-ar-id')];
        var top = card.querySelector('.ar-card-top');
        if (!r || r.vp !== true || !top || card.querySelector('.ar-badge--verified')) return;
        top.insertBefore(buildBadge(r), top.firstChild);
      });
    }

    // Lazy fetch of the JSON to pick up fresh stats. The fetch ALSO populates
    // state.allReviews so subsequent "Load more" clicks don't refetch.
    fetchData().then(function (data) {
      state.allReviews = (data.reviews || []).slice().sort(newestFirst);
      state.filteredTotal = state.allReviews.length;
      state.isLoaded = true;
      updateStatsFromMeta(data.meta);
      badgeSsrCards();
      // Apply the markup-declared default filter (e.g. 4★+) once data is ready;
      // for 'all' the SSR cards are kept (badged above).
      if (state.currentFilter !== 'all') render();
    }).catch(function (err) {
      // Soft fail — page still works with the SSR'd numbers
      console.warn('[ar-all] Could not refresh stats:', err);
      showFetchError();
    });

    filterBtns.forEach(function (btn) {
      btn.addEventListener('click', function () {
        ensureLoaded(function () {
          filterBtns.forEach(function (b) { b.classList.remove('is-active'); });
          btn.classList.add('is-active');
          syncAriaPressed();
          state.currentFilter = btn.dataset.filter;
          state.visibleCount = PAGE_SIZE;
          render();
        });
      });
    });

    // Disclosure button -> trigger "All" chip
    if (disclosureBtn) {
      disclosureBtn.addEventListener('click', function () {
        var allBtn = document.querySelector('.ar-all-filter[data-filter="all"]');
        if (allBtn) allBtn.click();
      });
    }

    loadMoreBtn.addEventListener('click', function () {
      ensureLoaded(function () {
        if (state.visibleCount === 24 && state.currentFilter === 'all') {
          // First click: jump to 48 to show progress
          state.visibleCount = 48;
        } else {
          state.visibleCount += PAGE_SIZE;
        }
        render();
      });
    });

    // ── Customer-photo lightbox (2026-06-10) ───────────────────────────────
    // Delegated in capture phase so a thumb click never triggers the card's
    // role=button behaviour. Built with safe DOM methods, no innerHTML.
    function closeLightbox() {
      var box = document.getElementById('arPhotoLightbox');
      if (box) box.remove();
      document.removeEventListener('keydown', onLightboxKey);
    }
    function onLightboxKey(e) {
      if (e.key === 'Escape') closeLightbox();
    }
    function openLightbox(baseUrl, altText) {
      closeLightbox();
      var box = el('div', { cls: 'ar-lightbox', attrs: { id: 'arPhotoLightbox', role: 'dialog', 'aria-modal': 'true', 'aria-label': altText } });
      var img = el('img', { attrs: { src: baseUrl + '?auto=format&w=1400', alt: altText } });
      var close = el('button', { cls: 'ar-lightbox__close', attrs: { type: 'button', 'aria-label': 'Close photo' }, text: '✕' });
      box.appendChild(img);
      box.appendChild(close);
      box.addEventListener('click', closeLightbox);
      document.addEventListener('keydown', onLightboxKey);
      document.body.appendChild(box);
      close.focus();
    }
    document.addEventListener('click', function (e) {
      var thumb = e.target && e.target.closest ? e.target.closest('[data-ar-photo]') : null;
      if (!thumb) return;
      e.preventDefault();
      e.stopPropagation();
      openLightbox(thumb.getAttribute('data-ar-photo'), thumb.getAttribute('aria-label') || 'Customer photo');
    }, true);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();

/* ── Full-review dialog + "Read more" cue (2026-10-30) ────────────────────────
 * Cards carry role="button" ("Read full review by …") but nothing opened, and
 * .ar-card-body is clamped to 3 lines. Click / Enter / Space now opens a native
 * <dialog> with the whole review; clamped cards get an overlaid "Read more" cue
 * (CSS ::after) so card heights are unchanged. DOM APIs + textContent only. */
(function () {
  'use strict';
  var SEL_CARD = '.ar-all-card';
  var dialog = null;
  var lastCard = null;

  function el(tag, cls, text) {
    var n = document.createElement(tag);
    if (cls) n.className = cls;
    if (text != null) n.textContent = text;
    return n;
  }

  function ensureDialog() {
    if (dialog) return dialog;
    dialog = el('dialog', 'ar-dialog');
    dialog.id = 'arReviewDialog';
    dialog.setAttribute('aria-labelledby', 'arReviewDialogTitle');
    var close = el('button', 'ar-dialog__close', '✕');
    close.type = 'button';
    close.setAttribute('aria-label', 'Close review');
    close.addEventListener('click', function () { dialog.close(); });
    var inner = el('div', 'ar-dialog__inner');
    inner.setAttribute('data-ar-dialog-inner', '');
    dialog.appendChild(close);
    dialog.appendChild(inner);
    dialog.addEventListener('click', function (e) { if (e.target === dialog) dialog.close(); }); // backdrop
    dialog.addEventListener('close', function () { if (lastCard && lastCard.focus) lastCard.focus(); });
    document.body.appendChild(dialog);
    return dialog;
  }

  function openFromCard(card) {
    var d = ensureDialog();
    var inner = d.querySelector('[data-ar-dialog-inner]');
    inner.textContent = '';
    var stars = card.querySelector('.ar-card-stars');
    var vbadge = card.querySelector('.ar-badge--verified');
    if (stars && vbadge) {
      // Badge + stars on one left-aligned row: the card's space-between row would push the stars under the close button.
      var head = el('div');
      head.style.cssText = 'display:flex;align-items:center;gap:10px';
      head.appendChild(vbadge.cloneNode(true));
      head.appendChild(stars.cloneNode(true));
      inner.appendChild(head);
    } else if (stars) inner.appendChild(stars.cloneNode(true));
    var t = card.querySelector('.ar-card-title');
    var h = el('h3', 'ar-dialog__title', t ? t.textContent : 'Customer review');
    h.id = 'arReviewDialogTitle';
    inner.appendChild(h);
    var b = card.querySelector('.ar-card-body');
    if (b) inner.appendChild(el('p', 'ar-dialog__body', b.textContent));
    var thumbs = card.querySelectorAll('[data-ar-photo]');
    if (thumbs.length) {
      var ph = el('div', 'ar-dialog__photos');
      Array.prototype.forEach.call(thumbs, function (th) {
        var src = th.getAttribute('data-ar-photo');
        if (!src) return;
        var img = el('img');
        img.src = src + (src.indexOf('?') === -1 ? '?w=600' : '');
        img.alt = th.getAttribute('aria-label') || 'Customer photo';
        img.loading = 'lazy';
        ph.appendChild(img);
      });
      inner.appendChild(ph);
    }
    var prod = card.querySelector('.ar-card-product') || card.querySelector('.ar-card-product__title');
    if (prod) inner.appendChild(prod.cloneNode(true));
    var foot = el('div', 'ar-dialog__foot');
    var av = card.querySelector('.ar-card-avatar');
    if (av) foot.appendChild(av.cloneNode(true));
    var meta = el('div', 'ar-card-meta');
    var name = card.querySelector('.ar-card-name');
    var date = card.querySelector('.ar-card-date');
    if (name) meta.appendChild(el('span', 'ar-card-name', name.textContent));
    if (date) meta.appendChild(el('span', 'ar-card-date', date.textContent));
    foot.appendChild(meta);
    inner.appendChild(foot);
    lastCard = card;
    if (typeof d.showModal === 'function') { d.showModal(); inner.scrollTop = 0; }
    else card.classList.toggle('is-expanded'); // very old browsers: expand in place
  }

  function cardFromTarget(t) {
    if (!t || !t.closest) return null;
    if (t.closest('a, button, [data-stop-modal], [data-ar-photo], .ar-dialog')) return null;
    return t.closest(SEL_CARD);
  }

  document.addEventListener('click', function (e) {
    var c = cardFromTarget(e.target);
    if (c) { e.preventDefault(); openFromCard(c); }
  });
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Enter' && e.key !== ' ') return;
    var c = e.target && e.target.closest ? e.target.closest(SEL_CARD) : null;
    if (c && e.target === c) { e.preventDefault(); openFromCard(c); }
  });

  // "Read more" cue: mark cards whose body is actually clamped.
  function markClamped() {
    var cards = document.querySelectorAll(SEL_CARD);
    Array.prototype.forEach.call(cards, function (card) {
      var body = card.querySelector('.ar-card-body');
      if (!body) return;
      card.classList.toggle('is-clamped', body.scrollHeight > body.clientHeight + 1);
    });
  }
  var timer = null;
  function schedule() { clearTimeout(timer); timer = setTimeout(markClamped, 60); }
  function start() {
    markClamped();
    var grid = document.querySelector('[data-ar-all-grid]');
    if (grid && window.MutationObserver) new MutationObserver(schedule).observe(grid, { childList: true });
    window.addEventListener('resize', schedule);
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(markClamped);
    window.addEventListener('load', markClamped);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
